export function showToast(message: string, duration = 2000): void {
  const el = document.createElement('div')
  el.textContent = message
  el.className = 'auth-toast'
  document.body.appendChild(el)
  setTimeout(() => el.remove(), duration)
}
